import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Account from 'lib/auth/Account';
import { sendBookingConfirmationWithToast } from 'v1/helpers/byModel/BookingConfirmationHelper';
import { openModal } from 'store/v1/ui/ui.actions';
import { DropdownMenuItem } from 'v5/design-system/DropdownMenu';
import { Send } from 'lucide-react';

const BookingConfirmationMenuItem = ({ bookingId }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const workspace = Account.resolveFirstWorkspace() || {};
  const bookings = useSelector(state => state.bookings);
  const resources = useSelector(state => state.contacts.data);
  const booking = get(bookings, ['data', bookingId]);
  const resourceId = get(booking, 'contact_id');
  const resource = get(resources, resourceId, {});

  const hasEmail =
    resource.emails &&
    resource.emails.length > 0 &&
    resource.emails.some(email => email.value_1);

  const onClick = () => {
    if (!hasEmail) {
      dispatch(
        openModal('AlertModal', {
          title: 'This resource has no email address',
          description:
            'You cannot send a booking confirmation to a resource without an email address. Please add an email address to the resource to continue.'
        })
      );
      return;
    }

    sendBookingConfirmationWithToast(bookingId, dispatch, {
      workspaceSchema: workspace.db_schema,
      history
    });
  };

  return (
    <DropdownMenuItem onSelect={onClick}>
      <Send />
      Send booking update
    </DropdownMenuItem>
  );
};

BookingConfirmationMenuItem.propTypes = {
  bookingId: PropTypes.number.isRequired,
  closeFlyover: PropTypes.func.isRequired
};

export default BookingConfirmationMenuItem;
